import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../__root";
import { z } from "zod";

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  validateSearch: z.object({
    verified: z.optional(z.boolean()),
    resetPasswordEmailSent: z.optional(z.boolean()),
    resetPassword: z.optional(z.boolean()),
    inviteToken: z.string().optional(),
  }),
}).lazy(() => import("./Login.lazy").then((d) => d.Route));
